<template>
  <a-card title="高级筛选" :class="bem.b()" :bordered="false">
    <template #extra>
      <ll-icon
        icon-name="icon-close2"
        :style="{
          cursor: 'pointer'
        }"
        @click="handleClose"
      />
    </template>
    <div :class="bem.m('content')">
      <ll-form
        v-if="props.filterColumns.length > 0"
        v-bind="$attrs"
        :form-columns="computeFormColumns"
        :form-options="props.formOptions"
        :form-data="innerValue"
        :row-options="
          $attrs['row-options'] || {
            gutter: 30
          }
        "
        @change="handleChange"
      />
      <div v-else :class="bem.m('empty')">
        <p>暂无数据</p>
      </div>
    </div>
    <div v-if="props.showFooter" :class="bem.m('footer')">
      <ll-button
        type="primary"
        style="margin-right: 16px"
        @click="handleAdvancedFilterConfirm"
      >
        确定
      </ll-button>
      <ll-button @click="handleClose">取消</ll-button>
    </div>
  </a-card>
</template>

<script setup lang="ts">
import { ref, watch, computed } from 'vue'
import { has, cloneDeep } from 'lodash-es'
import { createNamespace } from '@ll-plus/utils'
import { LlForm } from '@ll-plus/components'
import {
  advancedFilteringParamsProps,
  advancedFilteringParamsEmits,
  ALL_VALUE,
  initValue,
  filterAllValue
} from '../advanced-filtering'

import type { FormChangeEvent } from '@ll-plus/components'

defineOptions({ name: 'LlAdvancedFilteringParams' })

const props = defineProps(advancedFilteringParamsProps)

const emits = defineEmits(advancedFilteringParamsEmits)

const bem = createNamespace('advanced-filtering-params')

const innerValue = ref({})

const key = ref(0)

const computeFormColumns = computed(() => {
  return props.filterColumns.map(column => {
    if (has(column, 'options')) {
      if (
        (column.options.length && column.options[0].value === ALL_VALUE) ||
        column.unUseDefaultOption
      ) {
        return column
      }
      column.options = [
        {
          label: column?.defaultOptionLabel ?? '全部',
          value: ALL_VALUE
        },
        ...column.options
      ]
    }
    return column
  })
})

const handleClose = () => {
  emits('close')
}

const handleAdvancedFilterConfirm = () => {
  emits('confirm')
}

const handleChange = (params: FormChangeEvent) => {
  setData(params)
}

const setData = (params: FormChangeEvent) => {
  const value = cloneDeep(params.formData)
  const obj: Record<string, any> = {}
  computeFormColumns.value.forEach(item => {
    const i = item.key
    obj[i] = filterAllValue(value[i], item)
  })
  emits('update:value', obj)
  emits('changeValue', { ...params, formData: obj })
}

watch(
  () => props.value,
  val => {
    const value = cloneDeep(val)
    // const cloneInnerValue = cloneDeep(innerValue.value)
    const obj: Record<string, any> = initValue(computeFormColumns.value, value)

    // const comparedObj: Record<string, any> = initValue(
    //   computeFormColumns.value,
    //   cloneInnerValue
    // )
    // console.log({ obj, comparedObj, val }, innerValue.value)
    if (JSON.stringify(val) !== JSON.stringify(innerValue.value)) {
      innerValue.value = cloneDeep(obj)
    }
    if (key.value === 0) {
      innerValue.value = cloneDeep(obj)
      key.value++
    }
  },
  {
    deep: true,
    immediate: true
  }
)
// watch(
//   () => innerValue.value,
//   val => {
//     setData(val)
//   },
//   {
//     deep: true,
//     immediate: true
//   }
// )
</script>
